import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useVocabulary } from '../context/VocabularyContext';
import { FlashcardMode } from './index';

export function SessionScreen() {
  const { state, dispatch, actions } = useVocabulary();
  const { sessionConfig } = state;
  const { type } = sessionConfig;

  const handleBackToMenu = () => {
    dispatch({ type: actions.SET_APP_STATE, payload: 'menu' });
  };

  const getSessionTitle = () => {
    if (type === 'sentences') {
      return '🃏 Fiszki - Zdania';
    }
    return '🃏 Fiszki - Słownictwo';
  };

  const renderSessionContent = () => {
    // Both sentences and words use FlashcardMode
    return <FlashcardMode />;
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-gray-50 min-h-screen">
      {/* Navigation Header */}
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={handleBackToMenu}
          className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
          title="Powrót do Menu"
        >
          <ArrowLeft size={20} />
        </button>
        
        <div className="text-center">
          <h1 className="text-xl font-bold text-gray-800">
            {getSessionTitle()}
          </h1>
        </div>
        
        <div className="w-10"></div> {/* Spacer for centering */}
      </div>

      {/* Session Content */}
      {renderSessionContent()}
    </div>
  );
} 